module.exports = __webpack_public_path__ + "img/metting2.14479f07.png";